import { getFormValues } from 'redux-form'
import { toast } from 'react-toastify'
import { TABLA_MOVIMIENTOS_DE_MERCADERIA, TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES } from '../../../../../config/tables'
import moment from 'moment'
import { FORM_LISTADO_MOVIMIENTOS_MERCADERIA } from '../../../../../config/forms'
import MovimientoMercaderia from '../../../../../models/movimiento/movimiento_mercaderia'
import { COLUMNS_MOVIMIENTOS_DE_MERCADERIA, COLUMNS_TAREAS_MOVIMIENTO_MERCADERIA_PENDIENTES } from './constantesMovimientosDeMercaderia'
import { TablaMovimientoMercaderiaService } from '../servicio/TablaMovimientoMercaderiaService'
import { getTareaPorFecha } from '../../../../CuadroDeMandoMovimientos/actions'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false
      },
      id: TABLA_MOVIMIENTOS_DE_MERCADERIA
    })
  }
}

export function obtenerMovimientosDeMercaderia () {
  return (dispatch, getState) => {
    const state = getState()
    const movimientos = getFormValues(FORM_LISTADO_MOVIMIENTOS_MERCADERIA)(state)
    const fechaD = (movimientos) ? moment(movimientos.fechaD).format('YYYY-MM-DD')
      : moment(Date.now()).format('YYYY-MM-DD')
    const fechaH = (movimientos) ? moment(movimientos.fechaH).format('YYYY-MM-DD')
      : moment(Date.now()).format('YYYY-MM-DD')

    MovimientoMercaderia.getMovimientosMercaderia(fechaD, fechaH).then(callback)
    function callback (data) {
      /* const customToolbar = pdfCustomToolbarGenerator(
        'Camiones Rechazados En Calado',
        data,
        COLUMNS_CAMIONES_RECHAZADOS_EN_CALADO_TO_PRINT,
        'portrait') */
      const title = `Total de Movimientos entre el ${moment(fechaD, 'YYYY-MM-DD').format('DD/MM/YYYY')} y el ` +
      `${moment(fechaH, 'YYYY-MM-DD').format('DD/MM/YYYY')} => ${data.length} .`
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_MOVIMIENTOS_DE_MERCADERIA,
          data: data,
          title,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { print: true, filter: true, rowsPerPage: 100, rowsPerPageOptions: [100, 500, 1000] }
        },
        id: TABLA_MOVIMIENTOS_DE_MERCADERIA
      })
    }
    MovimientoMercaderia.getTotalMovimientosMercaderia(fechaD, fechaH).then(
      data => {
        dispatch({
          type: 'UPDATE_TOTALES',
          data: data.totalMovimientoMercaderia
        })
      }
    )
    toast.info('Operación realizada exitosamente.')
  }
}

export function actualizarDatosMovimientoMercaderiaPendiente () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      options: {
        enableTopToolbar: false,
        enableBottomToolbar: false,
        customToolbar: null
      },

      newState: {
        isLoading: true
      },
      id: TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES
    })
    TablaMovimientoMercaderiaService.getMovimientosMercaderiaPendientes().then(callback)
    function callback (data) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_TAREAS_MOVIMIENTO_MERCADERIA_PENDIENTES,
          data: data,
          title: false,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            print: false,
            pagination: false,
            filter: false,
            fixedSearch: false,
            search: false,
            download: false,
            filterValues: false,
            viewColumns: false,
            selectBarTop: false,
            sort: false
          }
        },
        id: TABLA_MOVIMIENTOS_DE_MERCADERIA_PENDIENTES
      })
    }
  }
}

export function updateTableMovimientosMercaderiaPendientes (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: COLUMNS_TAREAS_MOVIMIENTO_MERCADERIA_PENDIENTES
    })
  }
}

export function deleteTarea (fechaRegistroTarea) {
  return dispatch => {
    MovimientoMercaderia.deleteTareaMovimientoMercaderia(fechaRegistroTarea)
      .then(() => {
        dispatch(actualizarDatosMovimientoMercaderiaPendiente())
      })
  }
}

export function tareaPorFecha (fechaRegistroTarea) {
  return dispatch => {
    dispatch(getTareaPorFecha(fechaRegistroTarea))
  }
}

export function finalizarTareaPendiente (fechaRegistroTarea, tarea, fInicio, fFin, toneladas) {
  return dispatch => {
    TablaMovimientoMercaderiaService.finalizarTareaMovimientoMercaderia(fechaRegistroTarea, tarea, fInicio, fFin, toneladas)
      .then(() => {
        dispatch(actualizarDatosMovimientoMercaderiaPendiente())
      })
  }
}

export function updateTareaPendiente (fechaRegistroTarea, tarea, fInicio) {
  return dispatch => {
    TablaMovimientoMercaderiaService.updateTareaMovimientoMercaderia(fechaRegistroTarea, tarea, fInicio)
      .then(() => {
        dispatch(actualizarDatosMovimientoMercaderiaPendiente())
      })
  }
}
